import { render } from "./fourthstepGroomingView.vue?vue&type=template&id=8058d172&scoped=true"
import script from "./fourthstepGroomingView.vue?vue&type=script&lang=js"
export * from "./fourthstepGroomingView.vue?vue&type=script&lang=js"

import "./fourthstepGroomingView.vue?vue&type=style&index=0&id=8058d172&scoped=true&lang=css"

import exportComponent from "E:\\ph_ready_one\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8058d172"]])

export default __exports__